import httpClient from '../utils/httpClient';

const BASE_URL = '/system-admin';

/**
 * Verificar salud del sistema
 */
export const getSystemHealth = async () => {
  const response = await httpClient.get(`${BASE_URL}/health`);
  return response;
};

/**
 * Obtener lista de migraciones disponibles
 */
export const getAvailableMigrations = async () => {
  const response = await httpClient.get(`${BASE_URL}/migrations`);
  return response;
};

/**
 * Obtener estado de migraciones (ejecutadas vs pendientes)
 */
export const getMigrationStatus = async () => {
  const response = await httpClient.get(`${BASE_URL}/migrations/status`);
  return response;
};

/**
 * Ejecutar una migración específica
 */
export const executeMigration = async (fileName, userId = 1) => {
  const response = await httpClient.post(`${BASE_URL}/migrations/execute`, {
    fileName,
    userId
  });
  return response;
};

/**
 * Verificar si las tablas del sistema de liquidaciones existen
 */
export const verifyPayrollSystemTables = async () => {
  const response = await httpClient.get(`${BASE_URL}/payroll-system/verify`);
  return response;
};

export default {
  getSystemHealth,
  getAvailableMigrations,
  getMigrationStatus,
  executeMigration,
  verifyPayrollSystemTables
};
